import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

/**
 * Renew billable events request DTO
 */
export class RenewBillableEventsRequest {
	leasedBy!: string;
	@TransformDate()
	leasedUntil!: Date;
	@TransformInt()
	ids!: number[];
}
